import {
    Button,
    Card,
    CardHeader,
    CardBody,
    FormGroup,
    Form,
    Input,
    Container,
    Row,
    Col,
} from "reactstrap";
import Header from '../../components/Headers/Header';
import AdminNavbar from "../../components/Navbars/AdminNavbar/AdminNavbar";
import { useContext, useEffect, useRef, useState } from "react";
import { AuthContext } from "../../context/AuthContext";
import { EmpresaContext } from "../../context/EmpresaContext";
import { EmpresaType, EditEmpresaType } from "../../context/hooks/useEmpresa";
import useUser, { UserType, EditEmpresaUserType } from "../../context/hooks/useUser";
import LoadingSpinner from "../../components/LoadingSpinner/LoadingSpinner";
import ModalChangePassword from "../../components/ModalChangePassword/ModalChangePassword";

const ProfileEmpresa = () => {
    const { objUserTk } = useContext(AuthContext);

    const { handleGetUserById, user, setUser, updateEmpresaUser } = useUser();

    const [editPerfilState, setEditPerfilState] = useState<boolean>(true);
    const photoInputRef = useRef<HTMLInputElement>(null);
    const [openModalChangePassword, setOpenModalChangePassword] = useState(false);

    useEffect(() => {
        const fetchData = async () => {
            await handleGetUserById(objUserTk.UserId);
        };
        fetchData();
    }, []);

    const handleChange = (e: React.ChangeEvent<HTMLInputElement>) => {
        const { name, value, type, checked } = e.target;
        setUser((prevUser: UserType) => {
            if (!prevUser) return prevUser;
            return {
                ...prevUser,
                [name]: type === "checkbox" ? checked : value,
            };
        });
    };

    const handleEmpresaChange = (e: React.ChangeEvent<HTMLInputElement>) => {
        const { name, value } = e.target;
        setUser((prevUser: UserType) => {
            if (!prevUser) return prevUser;
            return {
                ...prevUser,
                empresa: {
                    ...(prevUser.empresa ?? {}),
                    [name]: value,
                },
            };
        });
    };

    const handleSalveIndoUser = async (update: UserType) => {
        const updateData: EditEmpresaUserType = {
            id: objUserTk.UserId,
            name: update.name,
            email: update.email,
            agencia: update?.empresa?.agencia || "",
            contaBeneficiario: update?.empresa?.contaBeneficiario || "",
            password: "",
            idUserType: update.idUserType,
        };
        await updateEmpresaUser(updateData);
        await handleGetUserById(objUserTk.UserId);
        setEditPerfilState(true);
    };

    return (
        <>
            <Header />
            <LoadingSpinner />
            <AdminNavbar brandText={"MEU PERFIL"} search={false} titleSearch={""} />
            <Container className="mt--3" fluid>
                <Row>
                    <Col className="order-xl-1" xl="8">
                        <Card className="bg-secondary shadow">
                            <CardHeader className="bg-white border-0">
                                <Row className="align-items-center">
                                    <div className="col-6 xs-8">
                                        <h3 className="mb-0">Minha conta</h3>
                                    </div>
                                    <Col className="text-right col-6" xs="4">
                                        <Button
                                            style={{ color: "#FFF", backgroundColor: "#585858" }}
                                            onClick={(e) => setOpenModalChangePassword(true)}
                                            size="sm"
                                        >
                                            Mudar senha
                                        </Button>
                                        {editPerfilState ? (
                                            <>
                                                <Button
                                                    style={{ color: "#FFF", backgroundColor: "#585858" }}
                                                    onClick={(e) => setEditPerfilState(false)}
                                                    size="sm"
                                                >
                                                    Editar seu perfil
                                                </Button>
                                            </>
                                        ) : (
                                            <>
                                                <Button
                                                    style={{ color: "#FFF", backgroundColor: "#585858" }}
                                                    onClick={() => handleSalveIndoUser(user)}
                                                    size="sm"
                                                >
                                                    Salvar edições
                                                </Button>
                                                <Button
                                                    style={{
                                                        color: "#585858",
                                                        border: " 1px solid #585858",
                                                    }}
                                                    onClick={() => setEditPerfilState(true)}
                                                    size="sm"
                                                >
                                                    Cancelar
                                                </Button>
                                            </>
                                        )}
                                    </Col>
                                </Row>
                            </CardHeader>
                            <CardBody>
                                <Form>
                                    <h6 className="heading-small text-muted mb-4">
                                        INFORMAÇÃO DO USUÁRIO
                                    </h6>
                                    <div className="pl-lg-4">
                                        <Row>
                                            <Col lg="12">
                                                <FormGroup>
                                                    <label
                                                        className="form-control-label"
                                                        htmlFor="input-first-name"
                                                    >
                                                        Nome completo
                                                    </label>
                                                    <Input
                                                        name="name"
                                                        value={user?.name}
                                                        onChange={handleChange}
                                                        disabled={editPerfilState}
                                                        className="form-control-alternative"
                                                        id="input-first-name"
                                                        placeholder="Nome"
                                                        type="text"
                                                    />
                                                </FormGroup>
                                            </Col>
                                        </Row>
                                        <Row>
                                            <Col lg="12">
                                                <FormGroup>
                                                    <label
                                                        className="form-control-label"
                                                        htmlFor="input-email"
                                                    >
                                                        Email
                                                    </label>
                                                    <Input
                                                        name="email"
                                                        value={user?.email}
                                                        onChange={handleChange}
                                                        disabled
                                                        className="form-control-alternative"
                                                        id="input-email"
                                                        placeholder="exemple@example.com"
                                                        type="email"
                                                    />
                                                </FormGroup>
                                            </Col>
                                        </Row>
                                    </div>
                                    <hr className="my-4" />
                                    <h6 className="heading-small text-muted mb-4">INFORMAÇÃO BANCÁRIA</h6>
                                    <div className="pl-lg-4">
                                        <Row>
                                            <Col lg="6">
                                                <FormGroup>
                                                    <label
                                                        className="form-control-label"
                                                        htmlFor="input-agencia"
                                                    >
                                                        Agência
                                                    </label>
                                                    <Input
                                                        name="agencia"
                                                        value={user.empresa?.agencia || ""}
                                                        onChange={handleEmpresaChange}
                                                        disabled={editPerfilState}
                                                        className="form-control-alternative"
                                                        id="input-agencia"
                                                    />
                                                </FormGroup>
                                            </Col>
                                            <Col lg="6">
                                                <FormGroup>
                                                    <label
                                                        className="form-control-label"
                                                        htmlFor="input-contaBeneficiario"
                                                    >
                                                        Conta Beneficiário
                                                    </label>
                                                    <Input
                                                        name="contaBeneficiario"
                                                        value={user.empresa?.contaBeneficiario || ""}
                                                        onChange={handleEmpresaChange}
                                                        disabled={editPerfilState}
                                                        className="form-control-alternative"
                                                        id="input-contaBeneficiario"
                                                    />
                                                </FormGroup>
                                            </Col>
                                        </Row>
                                    </div>
                                </Form>
                            </CardBody>
                        </Card>
                    </Col>
                </Row>
            </Container >
            <ModalChangePassword
                openModal={openModalChangePassword}
                closeModal={() => setOpenModalChangePassword(false)}
            />
        </>
    );
};

export default ProfileEmpresa;